<template>

      <D3BarChart :config="chart_config" :datum="data"></D3BarChart>

</template>

<script>

  import { D3BarChart } from 'vue-d3-charts';

  export default {
    components: {
      D3BarChart,
    },
    props: {
      data: Array,
    },
    data () {
      return {
        chart_config: {
          key: 'annee',
              w: 20,
          values: ['effectif'],
          color: {
            default: '#BB0000',
            current: '#BB0000',
          },
          orientation: "vertical",
          tooltip: {label: "Effectif"},
        },
      }
    }
  }

</script>

<style>
    .chart__bar--barchart:hover {
        fill: #D20000;
    }
</style>